import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
import React, { useEffect, useState } from 'react';
import { TwBfInput, TwBfLocation, TwBfLocationSelectType, TwBfPhone } from '@tw/tw-platform-rn';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { TwCheckbox, TwColumn, TwFormItem, TwPage, TwSection } from '@tw/tw-components-rn';

import { BfAppContext } from '@tw/tw-runtime';
import { ScrollView } from 'react-native';
import { SettingCreateAddressStore } from '../../stores/createAddress/setting-createAddress-store';
import { TwButton } from '@/app/components/tw-button/TwButton';
import { checkAddressParams } from '@/app/utils/utils';
import { styles } from './styles';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';

export const SettingCreateAddress = (props) => {
  const [store] = useState(() => new SettingCreateAddressStore());
  usePageStoreLifecycle(store, props.route.params);
  const state = useStoreState(store, (state) => state);
  const [name, setName] = useState(state.data?.linkmanName);
  const [phone, setPhone] = useState(state.data?.linkmanMobile);
  const [address, setAddress] = useState(state.data?.address);
  const [isDefault, setIsDefault] = useState(state.data?.isDef);

  const userInfo = BfAppContext.getInstance().getUserStore().getState().userInfo;

  useEffect(() => {
    if (state.mode === 'edit') {
      setName(state.data?.linkmanName);
      setPhone(state.data?.linkmanMobile);
      setAddress(state.data?.address);
      setIsDefault(state.data?.isDef);
    }
  }, [state.mode, state.data]);

  return (
    <BfPageStoreProvider store={store}>
      <TwPage translucentStatusBar={true}>
        <TwPage.Header title={'新增收货地址'}></TwPage.Header>
        <ScrollView style={styles.container}>
          <TwSection>
            <TwFormItem labelStyle={styles.label} label={'收货人'} pressable={true} required={true} readOnly={false}>
              <TwBfInput
                value={name}
                placeholder="收货人姓名"
                onChange={(value) => {
                  setName(value);
                }}
              ></TwBfInput>
            </TwFormItem>
            <TwFormItem labelStyle={styles.label} label={'手机号'} required={true} pressable={true}>
              <TwBfPhone
                value={phone}
                placeholder="手机号"
                onChange={(value) => {
                  setPhone(value);
                }}
              ></TwBfPhone>
            </TwFormItem>
            <TwBfLocation
              required={true}
              title={'所在地区'}
              detailAddressTitle="详细地址"
              defaultSelectType={TwBfLocationSelectType.area}
              value={address}
              onChange={(value) => {
                setAddress(value);
              }}
            ></TwBfLocation>
            {/* //TODO:设置为默认地址 */}
            <TwFormItem label={'设为默认地址'} labelStyle={styles.label} contentAlign={'right'}>
              <TwCheckbox
                checked={isDefault}
                onChange={(value) => {
                  setIsDefault(value);
                }}
              ></TwCheckbox>
            </TwFormItem>
          </TwSection>
          <TwColumn space={5} style={styles.commandContainer}>
            <TwButton
              shape={'round'}
              style={styles.button}
              variant={'solid'}
              onPress={async () => {
                const isOk = checkAddressParams(name, phone, address);
                if (!isOk) {
                  return;
                }

                store.setLoading(true);
                if (state.mode === 'edit') {
                  await store.addressService.update({
                    id: state.data.id,
                    linkmanName: name,
                    linkmanMobile: phone,
                    address: address,
                    isDef: isDefault
                  });
                } else if (state.mode === 'create') {
                  await store.addressService.create({
                    linkmanName: name,
                    linkmanMobile: phone,
                    address: address,
                    isDef: isDefault,
                    employeeId: {
                      id: userInfo.employee.id
                    }
                  });
                }
                store.setLoading(false);

                BfAppContext.getInstance().getRouteService().back();
              }}
            >
              保存
            </TwButton>

            {state.mode === 'edit' && (
              <TwButton
                shape={'round'}
                style={styles.button}
                variant={'outline'}
                onPress={async () => {
                  const confirm = BfAppContext.getInstance().getMessageService().showConfirm('确定删除吗？');
                  if (!confirm) {
                    return;
                  }

                  store.setLoading(true);
                  await store.addressService.delete({ id: state.data.id });
                  store.setLoading(false);

                  BfAppContext.getInstance().getRouteService().back();
                }}
              >
                删除
              </TwButton>
            )}
          </TwColumn>
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
